import { ListItemIcon, ListItemText, MenuItem, TextField } from '@mui/material';
import { UrgencyIcon } from 'features/geoEvents/components/UrgencyIcon';
import { GeoEventUrgencyLevel } from 'features/geoEvents/geoEvent.types';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type UrgencySelectorProps = {
  disabled?: boolean;
};

const urgencyOptions: {
  transKey: string;
  value: GeoEventUrgencyLevel;
}[] = [
  {
    transKey: 'geoEvent.urgency.stale',
    value: GeoEventUrgencyLevel.Stale,
  },
  {
    transKey: 'geoEvent.urgency.standard',
    value: GeoEventUrgencyLevel.Standard,
  },
  {
    transKey: 'geoEvent.urgency.medium',
    value: GeoEventUrgencyLevel.Medium,
  },
  {
    transKey: 'geoEvent.urgency.high',
    value: GeoEventUrgencyLevel.High,
  },
  {
    transKey: 'geoEvent.urgency.urgent',
    value: GeoEventUrgencyLevel.Urgent,
  },
];

export const UrgencySelector = (props: UrgencySelectorProps): JSX.Element => {
  const { disabled = false } = props;
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Controller
      name="urgency"
      control={control}
      render={({ field, fieldState }): JSX.Element => {
        const { ref, ...muiFieldProps } = field;
        return (
          <TextField
            select
            id="field-control-urgency"
            label={t('geoEvent.urgency.label')}
            fullWidth
            {...muiFieldProps}
            inputRef={ref}
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message}
            disabled={disabled}
            sx={{
              '.MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              },
            }}
          >
            {urgencyOptions.map(({ transKey, value: optionValue }) => {
              return (
                <MenuItem
                  key={transKey}
                  value={optionValue}
                  sx={{ textTransform: 'capitalize' }}
                >
                  <ListItemIcon sx={{ minWidth: 'fit-content' }}>
                    <UrgencyIcon urgency={optionValue} size={24} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t(transKey)}
                    slotProps={{
                      primary: { pt: 0.5 },
                    }}
                  />
                </MenuItem>
              );
            })}
          </TextField>
        );
      }}
    />
  );
};
